import React, { useContext } from "react";
import Marquee from "react-fast-marquee";

import "./Circular.css";

import { ThemeContext } from "../../contexts/ThemeContext";
import { skillsData } from "../../data/skillsData";
import { skillsImage } from "../../utils/skillsImage";
import { CircularProgress } from "@material-ui/core";
import { useState } from "react";
import { useEffect } from "react";

function Circular() {
  const { theme } = useContext(ThemeContext);

  const skillBoxStyle = {
    backgroundColor: theme.secondary,
    boxShadow: `0px 0px 12px ${theme.primary}`,
  };

  const [level, setLevel] = useState(0);

  useEffect(() => {
    const timer = setInterval(() => {
      setLevel((newLevel) => (newLevel >= 100 ? 0 : newLevel + 10));
    }, 500);

    return () => {
      clearInterval(timer);
    };
  }, []);

  return (
    <div className="skills" style={{ backgroundColor: theme.secondary }}>
      <div className="skillsHeader">
        {/* <h2 style={{ color: theme.primary }}>Skills Section</h2> */}
      </div>

      <div className="skillsContainer">
        {/* <div className="skill--scroll"> */}
        <div className="skill--scroll">
          <div className="skillsDivCircular">
            {/* heading */}

            <div className="frontend">
              <div className="skillsCircular">

                {/* Frontend */}

                <div className="skillBox box" style={skillBoxStyle}>
                  <div style={{ position: "relative" }}>
                    <span className="circularText">85%</span>
                    <CircularProgress
                      thickness={6}
                      size="8rem"
                      variant="determinate"
                      value={85}
                    />
                    <h3 style={{ color: theme.tertiary }}>Frontend</h3>
                  </div>
                </div>

                {/* Backend */}

                <div className="skillBox box" style={skillBoxStyle}>
                  <div style={{ position: "relative" }}>
                    <span className="circularText">78%</span>
                    <CircularProgress
                      thickness={6}
                      size="8rem"
                      variant="determinate"
                      value={78}
                    />
                    <h3 style={{ color: theme.tertiary }}>Backend</h3>
                  </div>
                </div>

                {/* DSA */}

                <div className="skillBox box" style={skillBoxStyle}>
                  <div style={{ position: "relative" }}>
                    <span className="circularText">70%</span>
                    <CircularProgress
                      thickness={6}
                      size="8rem"
                      variant="determinate"
                      value={70}
                    />
                    <h3 style={{ color: theme.tertiary }}>
                      Data Structures & Algorithm
                    </h3>
                  </div>
                </div>


              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Circular;
